var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom-user-select" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "b-popover",
              rawName: "v-b-popover.html",
              value: {
                container: "#app",
                trigger: "hover blur",
                content: _vm.defaultUserTooltip,
                placement: "top",
              },
              expression:
                "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: defaultUserTooltip,\n      placement: 'top',\n    }",
              modifiers: { html: true },
            },
          ],
          staticClass: "custom-user-select__user",
          class: { "active-user": _vm.selectedUsers.includes("default") },
          on: {
            click: function ($event) {
              return _vm.clickHandler($event)
            },
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "34",
                height: "34",
                viewBox: "0 0 34 34",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("circle", {
                attrs: { cx: "17", cy: "17", r: "17", fill: "#BFC9E0" },
              }),
              _c("path", {
                attrs: {
                  d: "M19.7779 18.1574L20.3334 18.9888L20.3334 18.9888L19.7779 18.1574ZM17.9755 9.09608L18.1705 8.11529L17.9755 9.09608ZM15.0866 9.3806L15.4693 10.3045L15.4693 10.3045L15.0866 9.3806ZM12.8427 11.2222L12.0112 10.6666L12.0112 10.6666L12.8427 11.2222ZM11 14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14H11ZM16 22C16 22.5523 16.4477 23 17 23C17.5523 23 18 22.5523 18 22H16ZM18.7335 18.6899L19.2825 19.5257L19.2825 19.5257L18.7335 18.6899ZM20.3334 18.9888C21.3201 18.3295 22.0892 17.3925 22.5433 16.2961L20.6955 15.5307C20.3928 16.2616 19.8801 16.8864 19.2223 17.3259L20.3334 18.9888ZM22.5433 16.2961C22.9974 15.1997 23.1162 13.9933 22.8847 12.8295L20.9231 13.2196C21.0775 13.9956 20.9983 14.7998 20.6955 15.5307L22.5433 16.2961ZM22.8847 12.8295C22.6532 11.6656 22.0818 10.5965 21.2426 9.75736L19.8284 11.1716C20.3878 11.731 20.7688 12.4437 20.9231 13.2196L22.8847 12.8295ZM21.2426 9.75736C20.4035 8.91825 19.3344 8.3468 18.1705 8.11529L17.7804 10.0769C18.5563 10.2312 19.269 10.6122 19.8284 11.1716L21.2426 9.75736ZM18.1705 8.11529C17.0067 7.88378 15.8003 8.0026 14.7039 8.45672L15.4693 10.3045C16.2002 10.0017 17.0044 9.92252 17.7804 10.0769L18.1705 8.11529ZM14.7039 8.45672C13.6075 8.91085 12.6705 9.67989 12.0112 10.6666L13.6741 11.7777C14.1136 11.1199 14.7384 10.6072 15.4693 10.3045L14.7039 8.45672ZM12.0112 10.6666C11.3519 11.6533 11 12.8133 11 14H13C13 13.2089 13.2346 12.4355 13.6741 11.7777L12.0112 10.6666ZM18 22C18 21.0628 18.1219 20.6518 18.2669 20.4045C18.4164 20.1494 18.6654 19.931 19.2825 19.5257L18.1846 17.854C17.5682 18.2588 16.9504 18.6955 16.5415 19.393C16.1281 20.0982 16 20.9372 16 22H18ZM19.2825 19.5257C19.3362 19.4904 19.4268 19.4484 19.6442 19.351C19.8213 19.2716 20.0893 19.1519 20.3334 18.9888L19.2223 17.3259C19.1387 17.3817 19.0212 17.4385 18.8265 17.5258C18.672 17.595 18.4044 17.7097 18.1846 17.854L19.2825 19.5257Z",
                  fill: "white",
                },
              }),
              _c("circle", {
                attrs: { cx: "17", cy: "26", r: "1", fill: "white" },
              }),
            ]
          ),
        ]
      ),
      _vm._l(_vm.users, function (user, userIndex) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: user.name,
                  placement: "top",
                },
                expression:
                  "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: user.name,\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            key: user.id,
            staticClass: "custom-user-select__user",
            class: { "active-user": _vm.selectedUsers.includes(user.id) },
            style: {
              transform: `translateX(-${userIndex + 1}0px)`,
            },
            on: {
              click: function ($event) {
                return _vm.clickHandler($event, user.id)
              },
            },
          },
          [
            _c("img", {
              attrs: {
                src: user.avatar || _vm.defaultUserAvatar,
                alt: user.id,
              },
              on: { error: _vm.replaceImageOnErrorLoad },
            }),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }